import { notifyError } from '@/libs/bugsnag/bugsnag'
import { fetch } from '@/services/client'
import { getAppConfig } from '@/config/config'

export interface FeatureFlags {
  toggles: Array<{
    name: string
    enabled: boolean
    variant?: object
  }>
}

export class FeatureFlagService {
  /**
   * Fetches the current feature flags from the Unleash API.
   * !This method is just available at server side!
   *
   * @returns A promise that resolves to the current feature flags
   */
  static async getFeatureFlags(): Promise<FeatureFlags> {
    const basePath = getAppConfig().basePath
    try {
      const response = await fetch(`${process.env.UNLEASH_BASE_URL}/proxy`, {
        method: 'GET',
        headers: {
          Authorization: process.env.UNLEASH_AUTH_KEY as string,
        },
        signal: AbortSignal.timeout(3000),
        next: {
          revalidate: 0,
        },
      })
      return await response.json()
    } catch (error: any) {
      notifyError('Unable to get feature flags from unleash', {
        scope: 'FeatureFlag.service',
        message: error.message,
        stack: error.stack,
      })
      return { toggles: [] } as FeatureFlags
    }
  }

  /**
   * Checks if a specific feature flag is enabled by name.
   * !This method is just available at server side!
   *
   * @param featureFlags - The feature flags object to check against
   * @param name - The name of the feature flag to check
   *
   * @returns boolean indicating if the feature flag is enabled
   */
  static isFeatureFlagEnabled(featureFlags: FeatureFlags, name: string): boolean {
    const flagToggle = featureFlags.toggles.find((toggle) => toggle.name === name)
    return flagToggle ? flagToggle.enabled : false
  }
}
